import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useScrolledNav } from "../lib/ui";
import { telHref } from "../lib/api";

export function useLenis() {
  // Native smooth scrolling (reliable across environments). Kept as a hook
  // so pages can opt in without extra wiring.
}

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  const y = el.getBoundingClientRect().top + window.pageYOffset - 70;
  window.scrollTo({ top: y, behavior: "smooth" });
}

export function Nav() {
  const scrolled = useScrolledNav();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const loc = useLocation();

  const go = (id) => {
    setOpen(false);
    if (loc.pathname === "/") scrollToId(id);
    else navigate("/#" + id);
  };

  const links = [
    ["auctions", "Auctions"], ["about", "About"], ["categories", "What We Sell"],
    ["locations", "Locations"], ["consign", "Consign"], ["contact", "Contact"],
  ];

  return (
    <header className={"nav" + (scrolled ? " scrolled" : "") + (open ? " open" : "")} data-testid="site-nav">
      <button className="brand" onClick={() => go("top")} data-testid="brand-logo" aria-label="TL Auctions home"
        style={{ background: "none", border: "none", cursor: "pointer" }}>
        <img src="/tl-emblem-mark.png" alt="" className="brand-img" />
        <span className="brand-word">TL&nbsp;AUCTIONS<em>AUCTIONS DONE RIGHT</em></span>
      </button>
      <nav className="nav-links">
        {links.map(([id, label]) => (
          <a key={id} onClick={() => go(id)} data-testid={`nav-${id}`}>{label}</a>
        ))}
      </nav>
      <button className="nav-toggle" onClick={() => setOpen((o) => !o)} aria-label="Menu" data-testid="nav-toggle">
        <span /><span />
      </button>
    </header>
  );
}

export function Footer({ settings }) {
  const navigate = useNavigate();
  const loc = useLocation();
  const s = settings || {};
  const go = (id) => (loc.pathname === "/" ? scrollToId(id) : navigate("/#" + id));
  return (
    <footer className="foot" data-testid="site-footer">
      <div className="foot-top">
        <div className="foot-brand">
          <img src="/tl-logo-lockup.png" alt="TL Auctions LLC — Auctions Done Right" className="foot-logo" />
          <p>Licensed &amp; bonded Texas auctioneers. Live, onsite &amp; simulcast auctions across the
            Dallas–Fort Worth metroplex since {s.years || "1996"}.</p>
        </div>
        <div className="foot-cols">
          <div>
            <h4>Explore</h4>
            <a onClick={() => go("auctions")}>Upcoming Auctions</a>
            <a onClick={() => go("categories")}>What We Sell</a>
            <a onClick={() => go("locations")}>Locations</a>
            <a onClick={() => go("about")}>About Us</a>
          </div>
          <div>
            <h4>Get Involved</h4>
            <a onClick={() => go("consign")}>Consign an Item</a>
            <a onClick={() => go("contact")}>Contact Us</a>
            <a onClick={() => navigate("/admin")}>Admin Login</a>
          </div>
          <div>
            <h4>Reach Us</h4>
            {s.phone && <a href={telHref(s.phone)}>{s.phone}</a>}
            {s.email && <a href={`mailto:${s.email}`}>{s.email}</a>}
            {s.address && <span className="muted">{s.address}</span>}
          </div>
        </div>
      </div>
      <div className="foot-bottom">
        <span>© {new Date().getFullYear()} Tommy Lutes Auctioneers · TL Auctions. All rights reserved.</span>
        <span className="mono">TX Licensed Auctioneer · Lic. #9612</span>
      </div>
      <div className="foot-credit">
        Powered &amp; designed by{" "}
        <a href="https://web-techservices.com" target="_blank" rel="noopener noreferrer" data-testid="webtech-credit">
          Web-techservices.com AI
        </a>
      </div>
    </footer>
  );
}
